import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/components/landing/LandingPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ProductsPage from "@/pages/ProductsPage";
import { CartProvider } from "@/contexts/CartContext";
import CartDrawer from "@/components/cart/CartDrawer";
import CartButton from "@/components/cart/CartButton";
import PromoBar from "@/components/PromoBar";

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <PromoBar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/produits" element={<ProductsPage />} />
          <Route path="/produit/:id" element={<ProductDetailPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <CartDrawer />
        <CartButton variant="floating" />
        <Toaster
          position="top-center"
          richColors
          closeButton
          toastOptions={{
            classNames: {
              toast: "!rounded-2xl !border !border-stone-200",
            },
          }}
        />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
